import type { EnvironmentProviders, Provider } from '@angular/core';
import { inject, provideEnvironmentInitializer } from '@angular/core';

import { MSAL_INSTANCE } from '@azure/msal-angular';
import type { IPublicClientApplication } from '@azure/msal-browser';
import { AuthService } from 'app/core/auth/auth.service';
import { RolesService } from 'app/core/auth/roles/roles.service';

export const provideAuth = (): (Provider | EnvironmentProviders)[] => {
  return [
    provideEnvironmentInitializer(() => {
      // Touch services to ensure early init
      const auth = inject(AuthService);
      const msal = inject(MSAL_INSTANCE) as unknown as IPublicClientApplication;
      const roles = inject(RolesService);
      // Attempt to derive role from Entra claims early
      roles.deriveRoleFromClaims(msal);
      return auth;
    }),
  ];
};
